module.exports = __webpack_public_path__ + "front/img/c5.e4af5890.png";